module.exports = __webpack_public_path__ + "img/banner103.7bb6ec07.jpeg";